import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-loading',
  imports: [],
  templateUrl: './loading.component.html',
  standalone: true,
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {

  @Input() height: number = 0;
}
